<div class="main">

  <div class="progress-bar-container">
    <mat-progress-bar mode="determinate" value={{progressBarValue}} class="custom-progress-bar"></mat-progress-bar>
    <!-- <p>{{progressBarValue + '%'}}</p> -->
  </div>

  <div class="chat" id="chat">
    <div class="cindi-img-container">
      <img alt="cindi" src="../../../assets/images/cindi.svg">
    </div>
  </div>

</div>
<app-loading-screen></app-loading-screen>
